const stripHtmlTags = (html: string): string => {
    return html
        ? html
              .replace(/<\/?[^>]+(>|$)/g, '') // replace html tags
              .replace(/(\r\n|\n|\r)/gm, '') // replace new lines
        : '';
};

export default stripHtmlTags;
